<template>
  <div>
     <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange"></search-form>
      <create-table :operationColWidth="150" @handleNewTab="handleNewTab($event, 'memberDetail')" :autoWidth="true" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick" :pageVisible="true" :pageData="pageData" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm" @cancle="search" :cancelVisible="false"></dialogEffect>
  </div>
</template>

<script>
import { getMemberApplySetup, getMemberApplyList, getUserGroupByUserType } from '@/services/members'
import { getCompanySimpleList } from '@/services/setting.js'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      isTabChange: false,
      cancleRefresh: false,
      userGroups: [],
      companies: []
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    const app_name = process.env.VUE_APP_NAME
    if (!app_name.includes('wholesale')) {
      this.tableDataItem.splice(5, 1)
    }
    const params = {
      scope: 'all'
    }
    this.initData()
    this.queryData(getMemberApplySetup, params)
  },
  activated () {
    if (this.isActive) this.queryData(getMemberApplySetup)
    this.isActive = true
  },
  methods: {
    initData () {
      getUserGroupByUserType('wholesale').then(res => {
        this.userGroups = res.data.user_groups
      })
      getCompanySimpleList().then(res => {
        this.companies = res.data.companies
      })
    },
    // 点击操作按钮
    async handleClick (type, data) {
      if (type?.action === 'view') {
        this.$router.push({
          name: 'memberApplyDetail',
          params: {
            id: data.id.value
          }
        })
      }
    },
    tabChange (index) {
      this.isTabChange = true
      const params = {
        scope: this.tabData[index].value
      }
      this.queryData(getMemberApplySetup, params)
    },
    // 查询
    search (data) {
      if (data === undefined && (this.batchData && this.batchData.path.includes('approve')) && !this.cancleRefresh) {
        const dialogData = {
          extra_params: [{
            hint: this.$t('form.members.creditLimit'),
            name: this.$t('form.members.billTip'),
            type: 'tip'
          }, {
            hint: this.$t('form.members.creditLimit'),
            key: 'credit_limit_f',
            optional: false,
            name: this.$t('form.members.creditLimit'),
            type: 'text'
          }, {
            hint: this.$t('form.members.billingCycle'),
            key: 'billing_cycle_mode',
            optional: false,
            name: this.$t('form.members.billingCycle'),
            type: 'select',
            options: [{
              name: this.$t('form.members.daily'),
              value: 'daily'
            }, {
              name: this.$t('form.members.anotherDay'),
              value: 'every_other_day'
            }, {
              name: this.$t('form.members.weekly'),
              value: 'weekly'
            }, {
              name: this.$t('form.members.monthly'),
              value: 'monthly'
            }]
          }, {
            hint: this.$t('form.members.userGroup'),
            key: 'user_group_id',
            optional: false,
            name: this.$t('form.members.userGroup'),
            type: 'select',
            options: this.userGroups,
            option_key: 'id',
            option_value: 'id'
          }, {
            hint: this.$t('form.members.company'),
            key: 'client_company_id',
            optional: false,
            name: this.$t('form.members.company'),
            type: 'select',
            options: this.companies,
            option_key: 'id',
            option_value: 'id'
          }, {
            hint: this.$t('form.members.password'),
            key: 'password',
            optional: false,
            name: this.$t('form.members.password'),
            type: 'text'
          }],
          parentParams: 'user',
          method: 'PUT',
          path: `/users/${this.batchData.path.split('/')[2]}`
        }
        this.batchData = dialogData
        this.dialogData = dialogData.extra_params
        this.dialogVisible = true
        this.cancleRefresh = true
        return
      }
      this.cancleRefresh = false
      if (this.isTabChange) {
        this.isTabChange = false
        return
      }
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getMemberApplyList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>

</style>
